<template>
  <LayoutDefault>
    <div class="container dark" id="notification_settings">
      <section class="block" style="padding: 3rem 0;">
        <h1 class="title">{{ $t('notification_settings.title') }}</h1>
        <div>
          <p class="notification_settings_label">
            {{$t('notification_settings.label')}}
          </p>
        </div>
        <!-- emails -->

        <div class="text-center" >
          <div class="email_switch_container">
          <label>
            {{$t('notification_settings.switch_label')}}
          </label>
          <div class="switch" :class="{ 'switch-on': emailNotifications }" @click="toggleEmailsNotifications">
            <div class="switch-handle"></div>
          </div>
        </div>
        </div>
        

      </section>

      <section class="block" style="display:flex;align-content: space-between;align-items: center;margin: 1rem auto;">
        <div style="flex:1;">
          <router-link class="support-link" :to="{ name: 'support' }">
            {{ $t('zammad_support.link') }}
          </router-link>
        </div>
        <div>
          <a @click="goBackOrHome" class="btn-go-back">&laquo;
            {{ $t('dashboard.back') }}
          </a>
        </div>
      </section>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Spinner from "../components/Spinner";
import resources from "../resources";

export default {
  components: {
    LayoutDefault,
    Spinner
  },
  data() {
    return {
      emailNotifications: null,
      sendingLoading: false,
      errorMessage: '',
      success: false
    };
  },
  methods: {

    goBackOrHome() {
      if (this.$route.meta.previousRoute) {
        this.$router.push(this.$route.meta.previousRoute);
      } else {
        this.$router.push({ name: "home" });
      }
    },
    toggleEmailsNotifications() {
      this.success = false;
      this.emailNotifications = !this.emailNotifications;
      resources.chatUpdateEmailNotifications.store()
        .then(data => {
          if (data.success) {
            this.success = true;
            this.errorMessage = '';
            this.emailNotifications = data.enabled;
          }
          else {
            this.errorMessage = 'error';
          }

          this.$auth.user().chat_email_notifications = this.emailNotifications;
        }).catch((err) => {
          this.errorMessage = err.body.message;
        });
    },
  },

  mounted() {
    const notificationsEnabled = !!(process.env.VUE_APP_NOTIFICATIONS_ENABLED && process.env.VUE_APP_NOTIFICATIONS_ENABLED === 'true');
    if(!notificationsEnabled){
      this.$router.replace({name: 'home'});
    }
    this.emailNotifications = this.$auth.user().chat_email_notifications || false;
  }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';

#notification_settings {
  box-sizing: border-box;
  min-height: 500px;
  padding: 9px;


  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;
    justify-content: center;
  }
}

.notification_settings_button {
  box-sizing: border-box;
  background-color: var(--pallete_main_color);
  color: white;
  padding: 0.5rem;
  margin: 1rem 0 0.5rem 0;
}

p.notification_settings_label {
  margin: 1em auto;
  text-align: justify;
  width: 50%;
  @media(max-width: 700px) {
    width: 80%;
  }
}

.email_switch_container{
  display: inline-flex;
}

.text-center{
  text-align: center;
}

.block {
  margin: 0 auto;
  width: 75%;

  & .success-message {
    color: green;
    font-size: 1rem;
  }

  & .error-message {
    color: var(--pallete_main_color);
    font-size: 0.9rem;
    padding: 0.3rem;
  }

  .title {
    border: 1px solid var(--pallete_main_color);

    border-radius: 35px;
    padding: 0.25em 1.5em;
    display: block;
    padding: 0.5rem;
    margin: 1em auto;
    text-align: center;
    background-image: linear-gradient(to left,
        var(--pallete_degrade_start_color),
        var(--pallete_degrade_finish_color) );
    color: var(--pallete_over_main_text_color);
    width: 400px;
    @media(max-width: 700px) {
        width: 300px;
    }
  }

  .title:not(:last-child) {
    margin-bottom: 0;
  }
}

.support-link {
  &:hover {
    font-weight: bold;
  }
}

.btn-go-back {
  color: var(--pallete_main_color);

  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
}

.switch {
  width: 60px;
  height: 30px;
  background-color: #ccc;
  border-radius: 15px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-left: 30px;
}

.switch-on {
  background-color: var(--pallete_main_color);
}

.switch-handle {
  width: 28px;
  height: 28px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 1px;
  transition: left 0.3s;
}

.switch-on .switch-handle {
  left: 31px;
}
</style>